var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave16W(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5C9.72391 1.5 11.3772 2.18482 12.5962 3.4038C13.8152 4.62279 14.5 6.27609 14.5 8C14.5 9.72391 13.8152 11.3772 12.5962 12.5962C11.3772 13.8152 9.72391 14.5 8 14.5C6.27609 14.5 4.62279 13.8152 3.40381 12.5962C2.18482 11.3772 1.5 9.72391 1.5 8C1.5 6.27609 2.18482 4.62279 3.40381 3.4038C4.62279 2.18482 6.27609 1.5 8 1.5ZM8.28691 11.5369L11.1307 8.69316C11.2475 8.57637 11.2805 8.40117 11.2195 8.25137C11.1586 8.10156 11.0088 8 10.8438 8H9.21875V5.5625C9.21875 5.11309 8.85566 4.75 8.40625 4.75H7.59375C7.14434 4.75 6.78125 5.11309 6.78125 5.5625V8H5.15625C4.99121 8 4.84395 8.09902 4.78047 8.25137C4.71699 8.40371 4.75254 8.57891 4.86934 8.69316L7.71309 11.5369C7.87051 11.6943 8.12949 11.6943 8.28691 11.5369Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave16W);
export default __webpack_public_path__ + "static/media/Save_16w.16a158257eb1ff5b093da576dcc336e4.svg";
export { ForwardRef as ReactComponent };